import styled from '@emotion/styled'
import { DEFAULT_FONT_STYLES, DEFAULT_THEME_COLORS } from 'css/theme'
import useFlow, { trackStepBackward } from 'modules/flow/state/use-flow'
import { UiIcon } from 'modules/ui/atoms/Icon'
import useDrawer from '../../../drawer/state/use-drawer'
import { useTranslation } from 'next-i18next'

export const STEP_LAYOUT_HEIGHT = '680px'
export const STEP_LAYOUT_BORDER_RADIUS = '20px'
export const STEP_LAYOUT_BACKGROUND_COLOR = 'white'
export const STEP_LAYOUT_SMALL_WIDTH = '440px'
export const STEP_LAYOUT_LARGE_WIDTH = '992px'

interface PrevStepButtonProps {
  iconName?: string
  size?: 'md' | 'lg'
  dataId?: string
  label?: string
}

export const PrevStepButton = ({
  iconName,
  size = 'md',
  dataId = '',
  label,
}: PrevStepButtonProps) => {
  const { t } = useTranslation()
  const flow = useFlow()
  const drawer = useDrawer()

  const prevStep = flow.prevStep

  if (!prevStep || !iconName) {
    return null
  }

  return (
    <StyledPrevStepButton
      size={size}
      type="button"
      data-id={dataId}
      onClick={() => {
        flow.goToStep(prevStep.name)
        trackStepBackward(prevStep.name, flow.currentStep.name)
        drawer.close()
      }}
      tabIndex={0}
    >
      <UiIcon name={iconName} w={16} h={16} />
      <span>{label ?? t('sharedStepLayout.PrevStepButton.backLabel', 'Back')}</span>
    </StyledPrevStepButton>
  )
}

const StyledPrevStepButton = styled.button<{ size: PrevStepButtonProps['size'] }>`
  padding: 0;
  background-color: transparent;
  z-index: 1;
  height: 40px;
  display: flex;
  align-items: center;
  gap: 8px;
  @media (max-width: 768px) {
    width: 100%; /* Width for mobile devices */
  }
  text-align: left;
  border: none;
  cursor: pointer;
  position: absolute;
  top: 20px;
  color: ${DEFAULT_THEME_COLORS['--theme-color--neutral-20']};
  font-size: ${({ size }) =>
    size === 'md'
      ? DEFAULT_FONT_STYLES['--theme-font--body-default__font-size']
      : DEFAULT_FONT_STYLES['--theme-font--title-large-page__font-size']};
  line-height: ${DEFAULT_FONT_STYLES['--theme-font--body-default__line-height']};
  left: 24px;

  span {
    font-size: 14px;
    line-height: 16px;
  }
`
